<script>
    import TheSlider from "@main/packages/TheSlider";
    import RecipeCard from "@miku-kz/components/recipes/RecipeCard";
    import { RECIPES_BREAKPOINTS } from "@miku-kz/settings/breakpoints";

    export default {
        name: "RecipeOthers",
        components: {
            TheSlider,
            RecipeCard,
        },
        props: {
            recipes: Array,
        },
        computed: {
            options() {
                return {
                    ...RECIPES_BREAKPOINTS,
                };
            },
        },
    };
</script>

<template>
    <div class="recipe-others">
        <div class="recipe-others__title">Еще рецепты</div>
        <the-slider
            nameSlider="recipeOthers"
            :is-bullets="true"
            :bullets-options="{ dynamicBullets: true }"
            :is-arrow="false"
            :options="options"
            :list="recipes"
        >
            <recipe-card
                slot="swiper-slide"
                class="swiper-slide"
                v-for="recipe in recipes"
                :key="recipe.id"
                :recipe="recipe"
            ></recipe-card>
        </the-slider>
    </div>
</template>

<style lang="scss">
    .recipe-others {
        .swiper-container {
            margin: 0 -16px;
            padding: 4px 16px;
            @include bp($bp-desktop-sm) {
                margin: 0 -16px;
                padding: 12px 16px;
            }
        }
    }

    .recipe-others__title {
        margin-bottom: 20px;
        font-size: 18px;
        font-weight: 700;
        line-height: 22px;
        text-align: center;
        @include bp($bp-desktop-sm) {
            margin-bottom: 12px;
            font-size: 26px;
            line-height: 40px;
        }
    }
</style>
